export default "__VITE_ASSET__BCcrd83Y__"